import { getConfig } from '@tcs/client-portal/config/configService';
import axios from 'axios';
import { useMutation } from 'react-query'; //TODO: can we modify our own useMutation to make POSTs work?

export const useInvestmentValuationMutation = (accountId, assetId, oktaAuth) =>
  useMutation(async (formData: FormData) => {
    const config = getConfig();
    const tokens = await oktaAuth.tokenManager.getTokens();
    const token = tokens.accessToken?.accessToken;
    assetId = encodeURIComponent(assetId);
    return axios.post(
      `${config.API_BASE_URL}/valuations/accounts/${accountId}/assets/${assetId}`,
      formData,
      {
        headers: {
          'Content-Type': `multipart/form-data;`,
          'x-tcs-authorization': token,
        },
      }
    );
  });

export default useInvestmentValuationMutation;
